<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="1200"
    :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card class="dialog-card">
      <v-toolbar class="dialog-toolbar" dark>
        <v-icon class="mr-2">business</v-icon>
        <v-toolbar-title class="dialog-title">{{ $t('Supplier') || 'Tedarikçi' }} {{ $t('Hotel-Section') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Combobox kullanarak hem listeden seçmeye hem de yeni yazmaya olanak tanıyoruz -->
      <v-combobox
        v-model="seciliTedarikci"
        :items="PROVIDER_LIST"
        item-text="urunAdi"
        return-object
        :label="$t('Hotel-Provider-Select')" 
        outlined
        dense 
        class="mt-4 mx-4"
      >
        <template v-slot:selection="{ item }">
          <span class="mr-2">{{ typeof item === 'string' ? item : item.urunAdi }}</span>
          <v-chip
            v-if="item"
            :color="isProviderActive(item) ? 'success' : 'error'"
            text-color="white"
            x-small
            class="font-weight-bold"
          >
            {{ isProviderActive(item) ? $t('Hotel-Active') : $t('Hotel-Passive') }}
          </v-chip>
        </template>

        <template v-slot:item="{ item }">
          <v-layout align-center justify-space-between style="width: 100%;">
            <span>{{ typeof item === 'string' ? item : item.urunAdi }}</span>
            <v-chip
              :color="isProviderActive(item) ? 'success' : 'error'"
              text-color="white"
              x-small
              class="font-weight-bold"
            >
              {{ isProviderActive(item) ? $t('Hotel-Active') : $t('Hotel-Passive') }}
            </v-chip>
          </v-layout>
        </template>
      </v-combobox>

      <v-divider />
      <v-card-text class="pa-4">
        <v-layout row wrap v-if="seciliTedarikci !== null && seciliTedarikci !== ''">
          <v-flex xs12>
            <GenericProviderInput 
              :providerData="getExistingProviderData(typeof seciliTedarikci === 'string' ? seciliTedarikci : seciliTedarikci.urunAdi)"
              @save="addOrEditProvider" 
            />
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn outline color="grey darken-1" @click="$emit('input', false)" class="action-btn">
          {{ $t('Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import hotelSearchService from './hotelSearchService';
import GenericProviderInput from '../comp/ucak/comp/ProviderInputs/GenericProviderInput.vue';

const PROVIDER_LIST = [
  { urunAdi: 'Paximum', id: 1 },
];

export default {
  name: 'ProviderAddDialog',
  props: {
    value: Boolean,
    sessionHeader: { type: Object, required: true },
    providers: { type: Array, default: () => [] }
  },
  data() {
    return {
      loading: false,
      seciliTedarikci: null,
      PROVIDER_LIST,
    };
  },
  components: {
    GenericProviderInput
  },
  methods: {
    isProviderActive(item) {
      if (!this.providers || this.providers.length === 0 || !item) return false;
      const name = typeof item === 'string' ? item : item.urunAdi;
      return this.providers.some(p => p.Provider && p.Provider.toLowerCase() === name.toLowerCase());
    },

    getExistingProviderData(providerName) {
      if (!this.providers || !providerName) return undefined;
      return this.providers.find(p => p.Provider && p.Provider.toLowerCase() === providerName.toLowerCase());
    },

    resetForm() {
      this.seciliTedarikci = null;
    },

    async addOrEditProvider(providerConfig, type) {
      this.loading = true;
      
      const providerName = typeof this.seciliTedarikci === 'string' ? this.seciliTedarikci : this.seciliTedarikci.urunAdi;
      
      const params = {
        SessionHeader: this.sessionHeader,
        Provider: providerConfig.Provider || providerName,
        ProviderType: 'Hotel', // Sadece Hotel olanları ekliyoruz
        ServiceUsername: providerConfig.ServiceUsername || '',
        ServicePassword: providerConfig.ServicePassword || '',
        ServiceSecurityKey: providerConfig.ServiceSecurityKey || '',
        Address: providerConfig.Address || '',
        IsTest: false,
        IsActive: true,
        OfficeId: providerConfig.OfficeId || null
      };

      try {
        if (type === 'edit') {
          // If editing, we also need to pass Id which was in providerConfig if it existed
          const existingData = this.getExistingProviderData(providerName);
          if (existingData && existingData.Id) {
            params.Id = existingData.Id;
          }

          const resp = await hotelSearchService.editCredential(this.$http, params);
          if (resp.body && resp.body.HasError === false) {
            this.$emit('notify', { type: 'success', message: this.$t('Hotel-Provider-Updated-Success') });
            this.$emit('added');
            this.resetForm();
          } else {
            const msg = (resp.body && resp.body.ErrorMessage) || this.$t('Hotel-Operation-Error');
            this.$emit('notify', { type: 'error', message: msg });
          }
        } else {
          const resp = await hotelSearchService.addCredential(this.$http, params);
          if (resp.body && resp.body.HasError === false) {
            this.$emit('notify', { type: 'success', message: this.$t('Hotel-Provider-Added-Success') });
            this.$emit('added');
            this.resetForm();
          } else {
            const msg = (resp.body && resp.body.ErrorMessage) || this.$t('Hotel-Operation-Error');
            this.$emit('notify', { type: 'error', message: msg });
          }
        }
      } catch (err) {
        this.$emit('notify', { type: 'error', message: this.$t('Hotel-Operation-Error') });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.dialog-card {
  border-radius: 12px;
  overflow: hidden;
}

.dialog-toolbar {
  background: linear-gradient(135deg, #1976D2, #1565C0) !important;
}

.dialog-title {
  font-size: 18px;
  font-weight: 500;
}

.action-btn {
  text-transform: none !important;
  border-radius: 8px !important;
}
</style>
